import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { AdvanceNoRocket } from "../../../components/AdvanceNoRocket";
import { Modal } from '../../../components/Modal';
import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { TaxDeduction } from "../../../components/TaxDeduction";
import { AccessLimited } from "../../../components/AccessLimited";

import { StructureBlocksOld } from "../../../components/LandingTemplates/kak_nauchit_rebenka_chitat";

import * as main from "./styles/main.module.scss";
import * as header from "./styles/header.module.scss";
import * as get from "./styles/get.module.scss";
import * as formula from "./styles/formula.module.scss";
import * as course from "./styles/course.module.scss";
import * as schema from "./styles/schema.module.scss";
import * as cost from "./styles/cost.module.scss";
import * as faq from "./styles/faq.module.scss";
import * as speaker from "./styles/speaker.module.scss";
import * as chance from "./styles/chance.module.scss";
import * as advance from "./styles/advance.module.scss";
import * as footer from "./styles/footer.module.scss";

const Header = () => {
  const [showModalTrial, setShowModalTrial] = React.useState(false);
  return (
    <header className={header.header}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={header.header__mainDesc}>
          <p className={`${main.blockTitle} ${main.blockTitleMd} ${main.purple} ${header.overtitle}`}>
            Онлайн-курс
          </p>
          <h1 className={main.title_h1}>Как научить ребёнка читать быстро и&nbsp;с&nbsp;умом</h1>
          <p className={header.header__desc}>
            Курс поможет школьникам 1–4-х классов научиться читать в&nbsp;2&nbsp;раза быстрее и&nbsp;развить память,
            внимание, мышление
          </p>
          <div className={header.btnBlock}>
            <button
              type="button"
              className={main.blockBtn}
              onClick={()=>{setShowModalTrial(true)}}
            >
              Посмотреть один урок бесплатно
            </button>
            <AccessLimited margin={"10px 0 0"} font={"13px"} align={"center"}/>
          </div>
        </div>
      </div>

      <Modal
        open={showModalTrial}
        onClose={() => {
          setShowModalTrial(false);
        }}
      >
        <GetCourseWidget hash={'525ac33ab48bccccb9cc1aee5437c8719b2ed4f3'} id={'128772'} />
      </Modal>
    </header>
  );
};

const Get = () => {
  return (
    <section className={get.get}>
      <div className="container">
        <div className="row">
          <div className={`col col-6 ${get.col}`}>
            <img
              src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/readgirl1.svg"
              alt=""
            />
          </div>
          <div className={`col col-6 ${get.col}`}>
            <h2 className={`${main.blockTitle} ${main.blockTitleLg} ${main.purple}`}>Что я получу</h2>

            <div className={get.get__block}>
              <h3>Затрачивая всего 15–20 минут в&nbsp;день, вы&nbsp;узнаете, как сделать так, чтобы ваш ребёнок:</h3>
              <ul className={get.checkList}>
                <li>Научился читать быстрее в&nbsp;1,5–2 раза и&nbsp;понимать прочитанное</li>
                <li>Улучшил память, внимание и&nbsp;мышление</li>
                <li>Повысил успеваемость в&nbsp;школе</li>
                <li>Загорелся любовью к&nbsp;чтению <br/><br/>
                  А&nbsp;также получите доступ к онлайн-тренажёру и&nbsp;детскую книгу для&nbsp;применения полученных
                  знаний на&nbsp;практике</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Formula = () => {
  return (
    <section className={formula.formula}>
      <div className="container">
        <div className={formula.formula__content}>
          <h2 className={`${main.blockTitle} ${main.blockTitleLg} ${main.purple}`}>
            Формула <br/> читающего ребёнка
          </h2>
          <p>
            <span className={main.blockTitleSm}>
              Опираясь на наши знания, мы&nbsp;вывели <br/> «Формулу читающего ребёнка»
            </span>
            На курсе мы&nbsp;расшифруем эту формулу. Вы получите полный багаж знаний о&nbsp;том, как научить вашего
            ребёнка читать быстро и&nbsp;как развить память, внимание и мышление.
          </p>
        </div>
      </div>

      <div className={formula.swipe}>
      </div>
      <div className={formula.railway}>
        <div className={formula.railwayScroll}>
          <div className={`row ${formula.row} ${formula.rowNoMrg}`}>
            <div className={`col ${formula.col}`}>
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/train-4.svg"
                alt="Train"
                className={formula.train4}
              />
            </div>
            <div className={`col ${formula.col}`}>
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/train-3.svg"
                alt="Train"
                className={formula.train3}
              />
            </div>
            <div className={`col ${formula.col}`}>
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/train-2.svg"
                alt="Train"
                className={formula.train2}
              />
            </div>
            <div className={`col ${formula.col} ${formula.trainCol}`}>
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/train-smoke.svg"
                alt="smoke"
                className={formula.smoke}
              />
              <img
                src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/train-1.svg"
                alt="Train"
                className={formula.train1}
              />
            </div>
          </div>
          <span className={formula.rails}></span>
        </div>
      </div>
    </section>
  );
};

const Course = () => {
  return (
    <section className={`${course.course} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${course.blockTitle} ${main.blockTitleLg} ${main.purple}`}>
          Почему наш курс
        </h2>
        <div className="row">
          <div className={`col col-4 ${course.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/why-icon-1.svg" alt=""/>
              <h6 className={`${main.blockTitleSm} ${main.purple}`}>
                Доступность
              </h6>
              <p>
                Из любой точки мира у&nbsp;вас есть доступ в&nbsp;личный кабинет, можно заниматься в&nbsp;любое время
                дня и&nbsp;ночи
              </p>
          </div>

          <div className={`col col-4 ${course.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/why-icon-2.svg" alt=""/>
              <h6 className={`${main.blockTitleSm} ${main.purple}`}>
                Мобильность
              </h6>
              <p>
                Курс адаптирован под телефон/планшет
              </p>
          </div>

          <div className={`col col-4 ${course.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/why-icon-3.svg" alt=""/>
              <h6 className={`${main.blockTitleSm} ${main.purple}`}>
                Экспертность
              </h6>
              <p>
                Курс разработал ведущий эксперт Advance с&nbsp;15-летним опытом работы в&nbsp;обучении детей
              </p>
          </div>

          <div className={`col col-4 ${course.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/why-icon-4.svg" alt=""/>
              <h6 className={`${main.blockTitleSm} ${main.purple}`}>
                Результат
              </h6>
              <p>
                Мы гарантируем: соблюдая все рекомендации, ваш ребёнок увеличит скорость чтения в&nbsp;1,5–2 раза
                за&nbsp;1&nbsp;месяц
              </p>
          </div>

          <div className={`col col-4 ${course.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/why-icon-5.svg" alt=""/>
              <h6 className={`${main.blockTitleSm} ${main.purple}`}>
                Сертификат
              </h6>
              <p>
                Именной сертификат Advance
              </p>
          </div>

          <div className={`col col-4 ${course.col}`}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/why-icon-6.svg" alt=""/>
              <h6 className={`${main.blockTitleSm} ${main.purple}`}>
                Положительные эмоции
              </h6>
              <p>
                Наш тренажёр для детей весёлый и&nbsp;интересный, с&nbsp;ним не&nbsp;хочется отвлекаться от&nbsp;заданий
              </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const Schema = () => {
  return (
    <section className={`${schema.schema} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${main.blockTitleLg} ${schema.blockTitleLg} ${main.purple}`}>
          Курс состоит из:
        </h2>
        <div className="row">
          <div className={`col col-3 ${schema.col}`}>
            <h3 className={`${main.blockTitle} ${main.blockTitleMd} ${main.purple}`}>
              Обучение для родителей
            </h3>
          </div>

          <div className={`col col-8 ${schema.col}`}>

            <StructureBlocksOld
              blockType={"schema"}
              ttlClassName={`${main.blockTitleSm} ${main.purple}`}
            />

          </div>
        </div>

        <div className={schema.course_reviews}>
          <div className={schema.course_reviewsBlock}>
            <iframe
              className={schema.course_reviewsBlock_video}
              width="100%"
              height="100%"
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_mM1tUFbwQHUlJOXC" frameBorder="0"
              title={"Youtube video"}
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const Cost = () => {
  const [showModalPack1, setShowModalPack1] = React.useState(false);
  const [showModalPack2, setShowModalPack2] = React.useState(false);
  const [showModalPack3, setShowModalPack3] = React.useState(false);
  return (
    <section className={`${cost.cost} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${cost.blockTitle} ${main.blockTitleLg} ${main.purple}`}>
          Стоимость:
        </h2>
        <div className="row">

          <div className={`col col-4 ${cost.col}`}>
            <div className={cost.pack}>
              <h3 className={main.blockTitleMd}>пакет 1</h3>
              <ul className={cost.checkList}>
                <li>Обучение для родителей</li>
              </ul>
              <div className={cost.mainCost}>
                <small>
                  <del>
                    27&nbsp;000&nbsp;₽
                  </del>
                </small>
                22&nbsp;900&nbsp;₽
              </div>
              <div className={cost.btnBlock}>
                <button type="button" className={main.blockBtn} onClick={()=>{setShowModalPack1(true)}}>
                  Купить
                </button>
              </div>
            </div>
          </div>

          <div className={`col col-4 ${cost.col}`}>
            <div className={cost.pack}>
              <h3 className={main.blockTitleMd}>пакет 2</h3>
              <ul className={cost.checkList}>
                <li>Обучение для родителей</li>
                <li>Тренажёр для детей</li>
                <li>Сборник для чтения с упражнениями</li>
              </ul>
              <div className={cost.mainCost}>
                <small>
                  <del>
                    55&nbsp;000&nbsp;₽
                  </del>
                </small>
                45&nbsp;900&nbsp;₽
              </div>
              <div className={cost.btnBlock}>
                <button type="button" className={main.blockBtn} onClick={()=>{setShowModalPack2(true)}}>
                  Купить
                </button>
              </div>
            </div>
          </div>

          <div className={`col col-4 ${cost.col}`}>
            <div className={cost.pack}>
              <h3 className={main.blockTitleMd}>пакет 3</h3>
              <ul className={cost.checkList}>
                <li>Обучение для родителей</li>
                <li>Тренажёр для детей</li>
                <li>Сборник для чтения с упражнениями</li>
                <li>5&nbsp;индивидуальных онлайн-консультаций разработчика курса</li>
              </ul>
              <div className={cost.mainCost}>
                <small>
                  <del>
                    70&nbsp;000&nbsp;₽
                  </del>
                </small>
                60&nbsp;900&nbsp;₽
              </div>
              <div className={cost.btnBlock}>
                <button type="button" className={main.blockBtn} onClick={()=>{setShowModalPack3(true)}}>
                  Купить
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className={cost.costUndertext}>*можно прибрести по мат.капиталу</p>
      <TaxDeduction className={cost.costUndertext}/>

      <Modal
        open={showModalPack1}
        onClose={() => {
          setShowModalPack1(false);
        }}
      >
        <GetCourseWidget hash={'24bdcb8d0765871badddd2c99c84740362b0d27b'} id={'189182'} />
      </Modal>
      <Modal
        open={showModalPack2}
        onClose={() => {
          setShowModalPack2(false);
        }}
      >
        <GetCourseWidget hash={'e53063de13cb38b728d0e57aeafc7861a7f8edc9'} id={'189194'} />
      </Modal>
      <Modal
        open={showModalPack3}
        onClose={() => {
          setShowModalPack3(false);
        }}
      >
        <GetCourseWidget hash={'2f9398bfbc28526be0dea94e9eb795122d4aa0e0'} id={'189211'} />
      </Modal>
    </section>
  );
};

const Speaker = () => {
  return (
    <section className={`${speaker.speaker} ${main.sec}`}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${speaker.blockTitle} ${main.blockTitleLg} ${main.purple}`}>
          Автор и&nbsp;ведущая курса
        </h2>
        <div className={`row ${speaker.row}`}>
          <div className={`col col-3 ${speaker.col}`}>
            <img
              src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/vecherina.png"
              alt="Наталья Сергеевна Вечерина"
            />
          </div>
          <div className={`col col-7 ${speaker.col}`}>
            <h3 className={`${main.blockTitleSm} ${main.purple}`}>
              Наталья Сергеевна Вечерина
            </h3>
            <p>
              Наталья Сергеевна&nbsp;— преподаватель высшей категории, ведущий специалист Advance по обучению детей
              эффективному чтению, руководитель методического отдела Advance, разработчик всех курсов и учебников
              Advance по технологиям обучения, практикующий педагог.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const Faq = () => {
  return (
    <section className={`${faq.faq} ${main.sec}`}>
      <div className="container">

        <h2 className={`${main.blockTitle} ${faq.blockTitle} ${main.blockTitleLg} ${main.purple}`}>
          Часто задаваемые вопросы:
        </h2>

        <StructureBlocksOld
          blockType={"faq"}
          ttlClassName={`${main.blockTitleSm} ${main.purple}`}
        />
      </div>
    </section>
  );
};

const Chance = () => {
  return (
    <section className={`${chance.chance} ${main.sec}`}>
      <div className="container">
        <div className={`row ${chance.row}`}>
          <div className={`col col-3 ${chance.col}`}>
            <img
              src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/readgirl2.svg"
              alt=""
            />
          </div>
          <div className={`col col-9 ${chance.col}`}>
            <h2 className={`${main.blockTitle} ${main.blockTitleLg} ${main.purple}`}>
              Воспользуйтесь шансом для вашего ребёнка
            </h2>
            <p>
              Умение эффективно работать с текстом — это преимущество, которое позволит вашим детям добиваться высоких
              результатов в жизни.
            </p>
            <div className={chance.btnBlock}>
              <a href="https://get.advance-club.ru/product/offer_trial_lesson?gc=pack6" target={"_blank"} rel={"noreferrer"}>
                <button className={main.blockBtn}>Записаться на пробный урок</button>
              </a>
              <AccessLimited margin={"10px 0 0"} font={"13px"} align={"center"}/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const FooterCustom = () => {
  return (
    <footer className={footer.footer}>
      <div className="container">
        <a
          href="https://vk.com/advanceclub"
          className={`${footer.socialLink} ${footer.vk}`}
          target={"_blank"} rel={"nofollow, noreferrer"}>
          <span className={"visually-hidden"}>Вконтакте</span>
        </a>
        <a
          href="https://ok.ru/group/52611362652241"
          className={`${footer.socialLink} ${footer.ok}`}
          target={"_blank"} rel={"nofollow, noreferrer"}>
          <span className={"visually-hidden"}>Одноклассники</span>
        </a>
        <a
          href="https://www.youtube.com/user/advanceclub?sub_confirmation=1"
          className={`${footer.socialLink} ${footer.yt}`}
          target={"_blank"} rel={"nofollow, noreferrer"}>
          <span className={"visually-hidden"}>Youtube</span>
        </a>
      </div>
    </footer>
  );
};

const TITLE = 'Онлайн-курс Как научить ребёнка читать быстро и с умом?';
const DESCRIPTION = 'Узнайте, как помочь ребенку читать в 2 раза быстрее и развить память, внимание и мышление.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{fontFamily: "Open Sans, sans-serif"}}>
      <Header/>
      <Get/>
      <Formula/>
      <Course/>
      <Schema/>
      <Cost/>
      <Speaker/>
      <Faq/>
      <Chance/>
      <AdvanceNoRocket
        sectionName={`${advance.advance} ${main.sec}`}
        ttlName={`${main.blockTitle} ${advance.blockTitle} ${main.blockTitleLg} ${main.purple}`}
        colCustomize={`col col-3 ${advance.col}`}
        blockName={advance.advance__block}
      />
    </main>

    <FooterCustom/>
  </DefaultLayout>
);

export default Page;
